import * as _colors from '../../../../../tokens/token-build/js/_colors.js';
import * as _variables from '../../../../../tokens/token-build/js/_variables.js';
import * as _semanticColorsLight from '../../../../../tokens/token-build/js/_semantic-colors-light.js';
import * as _semanticColorsDark from '../../../../../tokens/token-build/js/_semantic-colors-dark.js';
import * as _typography from '../../../../../tokens/token-build/js/_typography.js';

const THEME_NAME = {
    LIGHT: 'light',
    DARK: 'dark',
};
const baseTheme = {
    VARIABLES: _variables,
    COLORS: _colors,
    TYPOGRAPHY: _typography,
};
const defaultThemeLight = {
    ...baseTheme,
    SEMANTIC: {
        ..._semanticColorsLight,
    },
};
const defaultThemeDark = {
    ...baseTheme,
    SEMANTIC: {
        ..._semanticColorsDark,
    },
};

export { THEME_NAME, defaultThemeDark, defaultThemeLight };
